import { Card, Box, Typography, CardContent } from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import BackButton from "../bulk-operations/BackButton";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const ResultCards = ({
  totalRecords,
  searchType,
  totalFound,
  totalNotFound,
  totalFailed,
}) => {
  return (
    <>
      <Typography variant="h5" className="fw-bold _wg-dynamic-text mb-3 d-flex">
        <BackButton buttonIcon="yes" backUrl="/bulk-search" /> Search Results
      </Typography>
      <Box className="d-flex justify-content-between mb-2">
        <Card variant="outlined" className="result-card-bulk-search">
          <CardContent className="d-flex justify-content-between bs-pading">
            <div className="d-flex flex-column gap-1">
              <Typography variant="body2" className="_wg-dynamic-text">
                Total {searchType === "advance" ? "Queries" : "Records"}
              </Typography>
              <Typography variant="body2" className="_wg-dynamic-text">
                {totalRecords}
              </Typography>
            </div>
            <div className="results-icon records-icon">
              <ArticleIcon fontSize="medium" />
            </div>
          </CardContent>
        </Card>
        <Card variant="outlined" className="result-card-bulk-search">
          <CardContent className="d-flex justify-content-between bs-pading">
            <div className="d-flex flex-column gap-1">
              <Typography variant="body2" className="_wg-dynamic-text">
                Found
              </Typography>
              <Typography variant="body2" className="_wg-dynamic-text">
                {totalFound}
              </Typography>
            </div>
            <div className="results-icon tick-icon">
              <CheckCircleOutlineIcon fontSize="medium" />
            </div>
          </CardContent>
        </Card>
        <Card variant="outlined" className="result-card-bulk-search">
          <CardContent className="d-flex justify-content-between bs-pading">
            <div className="d-flex flex-column gap-1">
              <Typography variant="body2" className="_wg-dynamic-text">
                Not Found
              </Typography>
              <Typography variant="body2" className="_wg-dynamic-text">
                {totalNotFound}
              </Typography>
            </div>
            <div className="results-icon warning-icon">
              <WarningAmberRoundedIcon fontSize="medium" />
            </div>
          </CardContent>
        </Card>
        <Card variant="outlined" className="result-card-bulk-search">
          <CardContent className="d-flex justify-content-between bs-pading">
            <div className="d-flex flex-column gap-1">
              <Typography variant="body2" className="_wg-dynamic-text">
                Failed
              </Typography>
              <Typography variant="body2" className="_wg-dynamic-text">
                {totalFailed}
              </Typography>
            </div>
            <div className="results-icon cross-icon">
              <HighlightOffIcon fontSize="medium" color="error" />
            </div>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default ResultCards;
